import { useState, useEffect } from "react";
import * as Yup from "yup"; // ✅ Import Yup
import "../Stylesheets/Contact.css";

export default function Contact() {
  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const [formData, setFormData] = useState({
    Name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); // ✅ Store validation errors

  // ✅ Yup Validation Schema
  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Name is required").min(2, "Name is too short"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone must be 10 digits")
      .required("Phone is required"),
    message: Yup.string()
      .required("Message is required")
      .min(10, "Message must be at least 10 characters"),
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({}); // clear previous errors

    try {
      // ✅ Validate formData with Yup
      await validationSchema.validate(formData, { abortEarly: false });

      setLoading(true);

      const payload = {
        ...formData,
        userName: formData.Name,
        userMobile: formData.phone,
        userEmail: formData.email,
        message: formData.message,
      };

      const response = await fetch(
        "https://node.vidhvaa.co.in/api/techbridge/contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer cFRkdU1CYUhrRWZmUnZ5KmRDbGRoTFpVMklrNzVW6578a920b0ac2",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("API Success:", result);

      alert("Application Submitted Successfully!");
      setFormData({
        Name: "",
        email: "",
        phone: "",
        message: "",    
      });
    } catch (error) {
      if (error.name === "ValidationError") {
        // ✅ Collect validation errors
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("API Error:", error);
        alert("Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="enquire"
      className="py-3 text-light form-bg"
      style={{ overflowX: "hidden" }}
    >
      <div className="container-fluid contact-form">
        <div className="row mt-3 g-5 d-flex justify-content-center align-items-center">
          <div className="col-lg-1"></div>
          {/* Left Side: Form */}
          <div className="col-lg-5">
            <div
              className="card shadow border-1 p-5 form-control-custom"
              style={{
                background: "linear-gradient(180deg, black, #243b55, black)",
                width: "100%",
                maxWidth: "900px",
              }}
            >
              <h1
                className="fw-bold display-5 mb-5 gradient-text text-center"
                style={{ fontFamily: "'Merriweather', serif" }}
              >
                Contact Us{" "}
                <a>
                  <img
                    src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/nblogo27300_IMG.png"
                    style={{
                      width: "100%",
                      maxWidth: "50px",
                      cursor: "pointer",
                    }}
                  />
                </a>
              </h1>
              <form onSubmit={handleSubmit}>
                <div>
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="Name"
                    value={formData.Name}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Enter your name"
                  />
                  {errors.Name && (
                    <small className="text-danger">{errors.Name}</small>
                  )}
                </div>

                <div>
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="your@email.com"
                  />
                  {errors.email && (
                    <small className="text-danger">{errors.email}</small>
                  )}
                </div>

                <div>
                  <label className="form-label">Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Enter your mobile number"
                  />
                  {errors.phone && (
                    <small className="text-danger">{errors.phone}</small>
                  )}
                </div>

                <div className="col-12">
                  <label className="form-label">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows={4}
                    className="form-control"
                    placeholder="Tell us your queries..."
                  ></textarea>
                  {errors.message && (
                    <small className="text-danger">{errors.message}</small>
                  )}
                </div>

                <div className="col-12 d-flex justify-content-center py-4">
                  <button
                    type="submit"
                    style={{ color: "rgb(0 253 255)" }}
                    className="professional-glow prize-amount p-3 fw-bold w-75"
                    disabled={loading}
                  >
                    {loading ? (
                      "Submitting..."
                    ) : (
                      <>
                        <i className="fas fa-paper-plane me-2"></i> Contact Us
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Right Side: Contact Info */}
          <div className="col-lg-5 d-flex flex-column justify-content-center align-items-center text-light">
            <div className="d-flex flex-column">
              <h2
                className="display-6 fw-bold mb-5"
                style={{
                  color: "rgb(7, 223, 252)",
                  fontFamily: "'Merriweather', serif",
                }}
              >
                For Further Queries
              </h2>
              <div>
                <p className="mb-3 fs-5">📧 nb.techbridge@gmail.com</p>
                <p className="mb-4 fs-5">📞 +91 89259 59164</p>
                <p className="mb-4 fs-5">📞 +91 81488 80172</p>
                <p className="mb-4 fs-5">📞 +91 89259 59166</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
